import styled from 'styled-components/macro';
import { ListCheckTabStrip } from '../../../styles';

export const TemplateLine = styled.p`
  margin: 0 0 0 auto;
  font-size: 12px;
  color: ${({ theme }) => theme.color.gray[600]};

  b {
    font-weight: 600;
    color: ${({ theme }) => theme.color.gray[800]};
  }
`;

export const TabRow = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding-top: 16px;

  & > ${ListCheckTabStrip} {
    margin-top: 0;
    align-self: center;
  }
`;

export const ViewSwitchSpacer = styled.span`
  flex: 1;
`;

export const ViewSwitch = styled.div`
  display: flex;
  margin-right: 20px;
  border: 1px solid ${({ theme }) => theme.color.gray[200]};
  border-radius: 6px;
  overflow: hidden;
`;

export const ViewSwitchButton = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  border: none;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  background-color: ${({ $active, theme }) => ($active ? theme.color.gray[100] : 'white')};
  color: ${({ $active, theme }) => ($active ? theme.color.gray[900] : theme.color.gray[600])};

  & + & {
    border-left: 1px solid ${({ theme }) => theme.color.gray[200]};
  }

  &:hover {
    background-color: ${({ theme }) => theme.color.gray[100]};
  }

  svg {
    width: 14px;
    height: 14px;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.5;
  }
`;

export const CouldNotTellLine = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${({ theme }) => theme.color.gray[600]};
`;

export const ExpectedLine = styled.span`
  font-family: monospace;
  font-size: 11px;
  white-space: pre-wrap;
  color: ${({ theme }) => theme.color.gray[400]};
`;

export const RulesFound = styled.p`
  margin: 0 0 4px;
  font-size: 13px;
  color: ${({ theme }) => theme.color.gray[700]};
`;

export const ResultLines = styled.div`
  display: grid;
  gap: 8px;
  margin-bottom: 16px;
`;

export const OverviewIntro = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${({ theme }) => theme.color.gray[600]};
`;

export const TileChip = styled.span`
  margin-left: auto;
`;

export const TileRow = styled.p<{ $support: boolean; $found: boolean }>`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin: 0;
  font-size: 14px;
  color: ${({ $support, theme }) => ($support ? theme.color.gray[500] : theme.color.gray[900])};

  b {
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    color: ${({ $support, $found, theme }) =>
      !$support && $found
        ? theme.color.red[500]
        : $support
        ? theme.color.gray[500]
        : theme.color.gray[700]};
  }
`;
